import React, { useState } from 'react';
import { Modal, DatePicker } from 'antd';

const { RangePicker } = DatePicker;

/**
 * AiSummaryPeriodSelector Component
 * Manages the briefing period selection (Spec §12):
 * Options: Today, Past 24 Hours, Past 3 Days, Past Week (Default), Past 30 Days, Custom Range.
 */
export default function AiSummaryPeriodSelector({
    selectedPeriod,
    onPeriodChange,
    onCustomRangeSelect,
    disabled = false
}) {
    const [isCustomModalOpen, setIsCustomModalOpen] = useState(false);
    const [customDates, setCustomDates] = useState(null);

    const periods = [
        'Past Week',
        'Today',
        'Past 24 Hours',
        'Past 3 Days',
        'Past 30 Days',
        'Custom Range'
    ];

    const handleSelectChange = (e) => {
        const val = e.target.value;
        if (val === 'Custom Range') {
            setIsCustomModalOpen(true);
        } else {
            onPeriodChange?.(val);
        }
    };

    const handleApplyCustomRange = () => {
        if (customDates && customDates[0] && customDates[1]) {
            const startStr = customDates[0].toISOString();
            const endStr = customDates[1].toISOString();
            const label = `${customDates[0].format('MMM D')} – ${customDates[1].format('MMM D')}`;
            onCustomRangeSelect?.(label, startStr, endStr);
            setIsCustomModalOpen(false);
        }
    };

    return (
        <>
            <div className="relative inline-block">
                <select
                    value={selectedPeriod.startsWith('Custom:') ? 'Custom Range' : selectedPeriod}
                    onChange={handleSelectChange}
                    disabled={disabled}
                    className="bg-white/95 dark:bg-slate-800 border border-blue-200 dark:border-blue-900/60 rounded-lg text-xs font-bold text-[#03488A] dark:text-[#00AAF1] py-1 pl-2.5 pr-7 focus:ring-2 focus:ring-blue-500 cursor-pointer shadow-2xs outline-none transition-all disabled:opacity-50"
                >
                    {periods.map((p) => (
                        <option key={p} value={p}>
                            {p === 'Custom Range' && selectedPeriod.startsWith('Custom:')
                                ? selectedPeriod
                                : p}
                        </option>
                    ))}
                </select>
            </div>

            {/* Custom Range Modal */}
            <Modal
                title={
                    <div className="flex items-center gap-2">
                        <span className="material-symbols-outlined text-blue-600 text-base">date_range</span>
                        <span className="font-headline font-bold text-sm text-slate-800 dark:text-slate-200">
                            Select Custom Summary Range
                        </span>
                    </div>
                }
                visible={isCustomModalOpen}
                onCancel={() => setIsCustomModalOpen(false)}
                onOk={handleApplyCustomRange}
                okText="Apply Range"
                okButtonProps={{
                    disabled: !customDates || !customDates[0] || !customDates[1],
                    style: { background: '#03488A', borderColor: '#03488A' }
                }}
                width={440}
                centered
            >
                <div className="py-4 space-y-3">
                    <p className="text-xs text-slate-500 dark:text-slate-400">
                        Choose the historical period to analyze and generate your AI Inbox Summary briefing:
                    </p>
                    <RangePicker
                        className="w-full rounded-lg"
                        onChange={(dates) => setCustomDates(dates)}
                    />
                </div>
            </Modal>
        </>
    );
}
